import React from 'react'
import i18tn from 'i18next'
import PropTypes from 'prop-types'
import Api from '#services/api'
import UploadFeedbackBaseModal from './UploadFeedbackBaseModal'

function UploadFeedbackAsAzubiModal({onSuccess}) {
  const FeedbackTypes = Object.freeze({
    azubiZuAbteilung: 1,
    azubiZuAllgemein: 2,
  })

  const apiCallback = async (selectedFile, selectedOption) => {
    switch (selectedOption.value) {
      case FeedbackTypes.azubiZuAbteilung:
        return Api.uploadAzubiZuAbteilungFeedback(selectedFile)
      case FeedbackTypes.azubiZuAllgemein:
        return Api.uploadAzubiZuAllgemeinFeedback(selectedFile)
      default:
        return () => {}
    }
  }

  const feedbackOptions = [
    {
      value: FeedbackTypes.azubiZuAbteilung,
      label: i18tn.t('feedback_type_AzubiZuAbteilung'),
    },
    {
      value: FeedbackTypes.azubiZuAllgemein,
      label: i18tn.t('feedback_type_AzubiZuAllgemein'),
    },
  ]

  return (
    <UploadFeedbackBaseModal
      apiCallback={apiCallback}
      onSuccess={onSuccess}
      isLoadingOptions={false}
      dropdownOptions={feedbackOptions}
      dropdownPlaceholder={i18tn.t('upload_feedback_modal_as_azubi_dropdown_placeholder')}
      confirmDisabledReason={i18tn.t('upload_feedback_modal_as_azubi_confirm_button_disabled_reason')}
      uploadDescription={i18tn.t('upload_feedback_modal_as_azubi_description')}
    />
  )
}

UploadFeedbackAsAzubiModal.propTypes = {
  onSuccess: PropTypes.func,
}

export default UploadFeedbackAsAzubiModal
